<template>
    <app-framework>
        <template v-slot:title>
            <divider color="white"
                        width="56"
                        class="mb-3"
            ></divider>
            Dispersing Notions
        </template>
        <row class="z-10">
            <column class="text-secondary" cols="full">
                <row>
                    <column align="center" class="text-center mb-20" cols="full">
                        <divider class="mb-5" color="primary" width="56"></divider>
                        <div
                            class="poppins-bold tracking-normal xs:text-3xl sm:text-5xl xs:leading-relaxed sm:leading-higher">
                            <div class="xs:hidden">fitt Journey: Dispersing Notions</div>
                            <div class="sm:hidden">fitt Journey:<br>Dispersing Notions</div>
                        </div>
                    </column>
                    <column cols="full">
                        <row align="stretch">
                            <column :key="index" class="p-4" lg="1/3" md="1/2" sm="1/2"
                                    v-for="({title, subtitle}, index) in items"
                                    xl="1/4"
                                    xs="full"
                            >
                                <card class="h-full p-8">
                                    <divider class="mb-5" color="primary" width="56"></divider>
                                    <div class="uppercase poppins-bold text-lg text-primary tracking-wide mb-4">
                                        Notion {{ index + 1 }}
                                    </div>
                                    <div class="uppercase poppins-bold text-secondary tracking-wide text-xl mb-4"
                                         v-html="title"></div>
                                    <div class="text-secondary tracking-normal text-xl">
                                        {{ subtitle }}
                                    </div>
                                </card>
                            </column>
                        </row>
                    </column>
                </row>
            </column>
        </row>
    </app-framework>
</template>

<script>
    export default {
        name: "DispersingNotions",
        components: {
            'divider': () => import('@/components/Divider.vue'),
            card: () => import('@/components/Card.vue'),
            'app-framework': () => import('@/components/layout/AppFramework.vue'),
        },
        data: () => ({
            items: [
                {
                    title: 'assessment is<br>boring',
                    subtitle: 'fitt is an intuitive learning journey. Providing a rewarding candidate experience.'
                },
                {
                    title: 'assessment is<br>subjective',
                    subtitle: 'fitt incorporates a wide range of best practice assessment protocols into a single digital platform.'
                },
                {
                    title: 'online assessment cannot<br>be monitored',
                    subtitle: 'fitt deploys secure-assess technology for monitored and ethical administration front-to-end.'
                },
                {
                    title: 'quality assessment is<br>not scalable',
                    subtitle: 'fitt leverages exponential technologies for a premium solution at scale.'
                },
                {
                    title: 'assessments are<br>static',
                    subtitle: 'fitt provides agility at organizational and job role level.'
                },
                {
                    title: 'Assessments are for<br>recruitment',
                    subtitle: 'fitt provides an enterprise solution across talent management and-development domains.'
                },
                {
                    title: 'Quality assessment is<br>expensive',
                    subtitle: 'fitt leverages expert interpretation for every profile at cost efficient rates.'
                },
                {
                    title: 'assessments are done in<br>isolation',
                    subtitle: 'fitt renders analytics at individual and enterprise level - across domains, for predictive business-led decision making.'
                }
            ]
        }),
    }
</script>

<style scoped>

</style>